import React from 'react';

const WelcomeScreen = () => {
  return (
    <div className="chat-window" style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
        <div style={{marginBottom: '20px'}}>
             <div style={{width: '200px', height: '200px', background: '#e9edef', borderRadius: '50%', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <span style={{fontSize: '50px', color: '#aebac1'}}>Start Chat</span>
             </div>
        </div>
        <h2 style={{color: '#41525d', fontWeight: 300}}>Bookfast WhatsApp</h2>
        <p style={{color: '#667781'}}>Send and receive messages without keeping your phone online.</p>
    </div>
  );
};

export default WelcomeScreen;